import { render, staticRenderFns } from "./fixRight.vue?vue&type=template&id=6dc82777&scoped=true&"
import script from "./fixRight.vue?vue&type=script&lang=js&"
export * from "./fixRight.vue?vue&type=script&lang=js&"
import style0 from "./fixRight.vue?vue&type=style&index=0&id=6dc82777&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc82777",
  null
  
)

export default component.exports